export abstract class SharedObjectBaseService {
  abstract create(objectId: string, permissions: any, invites: any[], note: string, skip: boolean)
  abstract update(uuid: string, payload: any)
  abstract add(uuid: string, invites: any[], note: string, skip: boolean)
  abstract remove(uuid: string, invite: any)
  abstract sharedObject(uuid: string)
}